import { useState, useCallback, useEffect, useRef } from "react"; 
import api from "../api/axios";

export default function useMailFetch(workspaceId) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [error, setError] = useState(null);
  const currentWorkspaceIdRef = useRef(workspaceId);

  const [results, setResults] = useState(() => {
    if (!workspaceId) return [];
    const savedResults = localStorage.getItem(`results_${workspaceId}`);
    return savedResults ? JSON.parse(savedResults) : [];
  });

  useEffect(() => {
    currentWorkspaceIdRef.current = workspaceId;
    setError(null);
    setIsLoading(false);

    if (workspaceId) {
      const savedResults = localStorage.getItem(`results_${workspaceId}`);
      if (savedResults) {
        setResults(JSON.parse(savedResults));
        setIsDataFetched(true);
      } else {
        setResults([]);
        setIsDataFetched(false);
      }
    } else {
      setResults([]);
      setIsDataFetched(false);
    }
  }, [workspaceId]);

  const execute = useCallback(async (searchCriteria) => {
    if (!workspaceId) {
      setError("No workspace selected");
      return;
    }

    const initialWorkspaceId = workspaceId;
    setIsLoading(true);
    setError(null);

    try {
      const payload = {
        workspaceId: workspaceId,
        ...searchCriteria
      };

      const response = await api.post("/mail/search", payload);

      // Only update state if we are still on the same workspace
      if (currentWorkspaceIdRef.current === initialWorkspaceId) {
        if (Array.isArray(response.data)) {
          const newResults = response.data;
          setResults(newResults);
          localStorage.setItem(`results_${workspaceId}`, JSON.stringify(newResults));
        } else {
          setResults([]);
          console.warn("API returned non-array:", response.data);
        }
        setIsDataFetched(true);
      }
      
    } catch (err) {
      // Only update state if we are still on the same workspace
      if (currentWorkspaceIdRef.current === initialWorkspaceId) {
        console.error("Search error:", err);
        const msg = err.response?.data?.message || "Failed to fetch emails.";
        setError(msg);
      }
    } finally {
      if (currentWorkspaceIdRef.current === initialWorkspaceId) {
        setIsLoading(false);
      }
    }
  }, [workspaceId]);

  return { isLoading, isDataFetched, error, results, execute };
}